import { Spin, SpinProps } from 'antd';
import styles from './page-spinner.module.css';

interface Props {
  size?: SpinProps['size'];
}

const PageSpinner = ({ size = 'large' }: Props): JSX.Element => {
  return (
    <div className={styles.container}>
      <Spin size={size} />
    </div>
  );
};

export default PageSpinner;
